import {DashboardMenu} from './components/menu'

import {Dashboard} from './components/dashboard'
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    menu: DashboardMenu,
    dashboard: Dashboard
}
